import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import { get } from 'lodash';

import { Button } from 'components/Button';
import MobileHeader from 'components/Header/MobileHeader';
import Input from 'components/Form/Input';
import { numberUnmask } from 'utils/unmask';

import {
  nextAction,
} from 'actions/workflow';

import style from './style.scss';


const SSNCheck = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [ssnLast4Digits, setSsnLast4Digits] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const data = useSelector((state) => get(state, 'workflow.data.data'));

  useEffect(() => {
    document.querySelector('#root').style.backgroundColor = '#E3E2E1';

    if (!data) {
      navigate(`/fsl/application${window.location.search}`);
    }

    return () => {
      document.querySelector('#root').style.backgroundColor = '#fff';
    };
  }, []);

  const handleChange = (e) => {
    setSsnLast4Digits(e.target.value);
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();

    setIsLoading(true);
    dispatch(nextAction({
      data: {
        ssnLast4Digits,
      },
      url: `/workflows/fsl/${searchParams.get('key')}/next`,
      success: (response) => {
        setIsLoading(false);
        navigate(response.data.url);
      },
      fail: (error) => {
        setIsLoading(false);
        setErrorMessage(get(error, 'data.failure.errors.0.message') || 'Please try again');
      },
    }));
  };

  return (
    <div className={style['ssn-check-page']}>
      <MobileHeader />
      <section className={cn('container', style['ssn-check-section'])}>
        <div className={style['welcome-title']}>Welcome back, { data && data.firstName }!</div>
        <div className={cn('text-center', style['mb-10'])}>Please enter the last 4 of your SSN to verify your identity.</div>
        <Input
          labelClassName="w-100"
          label="Last 4 Digits of Your SSN"
          name="SsnLast4Digits"
          isRequired
          isMasked={[/\d/, /\d/, /\d/, /\d/]}
          notification="To protect your identity and for security purposes please enter the last 4 digits of your Social Security Number."
          notificationClass="notificationFromTop"
          value={ssnLast4Digits}
          onChange={handleChange}
          errorClassName="text-center"
          errorMessage={errorMessage}
        />
      </section>
      <div className={style.footer}>
        <Button
          className={cn('button', style.btn, { [style.arrow]: !isLoading })}
          onClick={handleSubmitForm}
          isDisabled={numberUnmask(ssnLast4Digits).length !== 4}
          isLoading={isLoading}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

export default SSNCheck;
